<div>
  <div class="dropdown-wrapper">
    <p-dropdown
      [options]="items"
      [(ngModel)]="selectedLink"
      (onChange)="onSelectionChange($any($event).value)"
      optionLabel="name"
      optionValue="link"
      placeholder="Select a Spec"
    >
      <ng-template let-option pTemplate="selectedItem">
        {{ option.name }}
        @if (option.isDeprecated) {
          <span class="text-red">(deprecated)</span>
        }
      </ng-template>
      <ng-template let-option pTemplate="item">
        {{ option.name }}
        @if (option.isDeprecated) {
          <span class="text-red">(deprecated)</span>
        }
      </ng-template>
    </p-dropdown>
  </div>

  @if (selectedLink) {
    <swagger-doc [link]="selectedLink"></swagger-doc>
  }
</div>
